(function(){
  function shuffle(items){
    for(var i=items.length-1;i>0;i--){
      var j=Math.floor(Math.random()*(i+1));
      var temp=items[i];items[i]=items[j];items[j]=temp;
    }
    return items;
  }
  function fill(root){
    var options=shuffle([].slice.call(root.querySelectorAll('[data-thread-option]')));
    if(!options.length)return;
    root.querySelectorAll('[data-thread-slot]').forEach(function(slot,index){
      var item=options[index%options.length];
      var image=slot.querySelector('img');
      slot.href=item.dataset.url;
      image.src=item.dataset.image;
      image.alt=item.dataset.title;
      slot.querySelector('[data-thread-title]').textContent=item.dataset.title;
      slot.querySelector('[data-thread-vendor]').textContent=item.dataset.vendor;
      slot.hidden=false;
      window.setTimeout(function(){slot.classList.add('is-loaded');},index*70);
    });
  }
  function init(scope){scope.querySelectorAll('[data-thread-page]').forEach(fill);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});
  else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();